export default {
  STATUSES: {
    ERROR: 'error',
    ABORTED: 'aborted',
    UPLOADING: 'uploading',
    PROCESSING: 'processing',
    TIMEOUT: 'timeout',
    DONE: 'uploaded',
  },
};
